import { render, staticRenderFns } from "./LeagueTab.vue?vue&type=template&id=47847ac8&"
import script from "./LeagueTab.vue?vue&type=script&lang=js&"
export * from "./LeagueTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports